import { renderMarketingPage, SUPPORT_EMAIL } from './shared.js';

export function renderContact(container, signedIn) {
  const body = `
    <main class="mkt-main">
      <section class="mkt-page-hero">
        <h1>Contact us</h1>
        <p>We read every message. For account or billing issues, include the email you signed up with.</p>
      </section>

      <section class="mkt-section">
        <div class="contact-grid">
          <div class="contact-info">
            <div class="contact-info-row">
              <span class="contact-info-label">Support email</span>
              <a href="mailto:${SUPPORT_EMAIL}">${SUPPORT_EMAIL}</a>
            </div>
            <div class="contact-info-row">
              <span class="contact-info-label">Response time</span>
              <span>Usually within 1–2 business days</span>
            </div>
            <div class="contact-info-row">
              <span class="contact-info-label">Business hours</span>
              <span>Mon–Fri, 10:00–18:00 IST</span>
            </div>
          </div>

          <form id="contact-form" class="contact-form card">
            <div class="field">
              <label>Name</label>
              <input type="text" id="c-name" required />
            </div>
            <div class="field">
              <label>Email</label>
              <input type="email" id="c-email" required />
            </div>
            <div class="field">
              <label>Message</label>
              <textarea id="c-message" rows="5" required></textarea>
            </div>
            <button type="submit" class="btn btn-primary" style="width:100%;justify-content:center;">Send message</button>
            <p class="contact-form-note">This opens your email app with the message pre-filled, addressed to ${SUPPORT_EMAIL}.</p>
          </form>
        </div>
      </section>
    </main>
  `;
  renderMarketingPage(container, '/contact', signedIn, body);

  const form = container.querySelector('#contact-form');
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const name = container.querySelector('#c-name').value.trim();
    const email = container.querySelector('#c-email').value.trim();
    const message = container.querySelector('#c-message').value.trim();
    const subject = encodeURIComponent(`Message from ${name} via Simustage`);
    const bodyText = encodeURIComponent(`${message}\n\n— ${name} (${email})`);
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${bodyText}`;
  });
}
